import * as React from 'react';
export const deutschebankSvg = React.forwardRef(function deutschebankSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#0018A8',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        fillRule: 'nonzero',
        d: 'M4.36 4.36v23.32h23.28V4.36H4.36zm14.55 2.91h5.85L13.12 24.73H7.27L18.91 7.27z',
      }),
    ),
  );
});
deutschebankSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var deutschebank = {
  category: 'brand',
  colorable: false,
  name: 'deutschebank',
  svg: deutschebankSvg,
};
